export const GetAllEventLogs = '/api/EventLogs/GetAllEventData';
export const DownloadFileAddress = '/api/EventLogs/DownloadFile?blobPath=';
export const ALL_URLS_ADDRESS = '#';
export const GetAllGeneratedMessages = '/api/GeneratedMessage/GetAllGeneratedMessage';